export default {
  Tableware: 'Tableware',
  'Special Instructions:': 'Special Instructions:',
  Qty: 'Qty',
  Item: 'Item',
  Price: 'Price',
  Total: 'Total',
  'Price per head': 'Price per head',
  '{{perHead}}/person': '{{perHead}}/person',
};
